import { QUESTION_TYPES_HELP_URL } from '../../utilities/constants';

import styles from './_index.module.scss';

const TypeUnselectedPlaceholder = () => {
  return (
    <div className={styles['type-unselected-placeholder']} data-testid="question-type-empty-state">
      <div className={styles['type-unselected-placeholder-inner']}>
        <h2 className={styles['type-unselected-placeholder-title']}>Select Question Type</h2>
        <p className={styles['type-unselected-placeholder-copy']}>
          Pick a question type from the left sidebar.
        </p>
        <a
          className={styles['type-unselected-placeholder-link']}
          data-testid="question-type-learn-more"
          href={QUESTION_TYPES_HELP_URL}
          rel="noreferrer"
          target="_blank"
        >
          Learn more
        </a>
      </div>
    </div>
  );
};

export default TypeUnselectedPlaceholder;
